import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { $ } from 'protractor';
import { CustomExceptionService } from 'src/app/errorHandlers/custom-exception.service';
import { usererrors } from 'src/app/errors/usererrors';
import { AddOnCommission } from 'src/app/Models/AddOnCommission';
import { BookingCommission } from 'src/app/Models/BookingCommission';
import { CustomerSiteContractAddOnCharge } from 'src/app/Models/CustomerSiteContractAddOnCharge';
import { PrequoteContractConversion, Userdetails } from 'src/app/Models/PrequoteContractConversion';
import { ContractconversionService } from 'src/app/Services/contractconversion.service';
import { CustomerSiteCostAndContractService } from 'src/app/Services/customer-site-cost-and-contract.service';
import { vContract, vConversion } from 'src/app/Validators/validation';
import { CommonUtilities } from 'src/assets/js/common-utilities';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-c-prequotecontractconversion',
  templateUrl: './c-prequotecontractconversion.component.html',
  styleUrls: ['./c-prequotecontractconversion.component.css']
})
export class CPrequotecontractconversionComponent implements OnInit {
  public _Url = environment.Url;
  _ConversionForm: FormGroup
  _Commissionform: FormGroup
  tempconversionform: FormGroup
  ContractConversion: PrequoteContractConversion
  ExistConversionList: any[] = []
  CustomerList: any[]
  SelectCustomerList: any
  CommissionConfigList: BookingCommission[] = []
  selectedtab: number = 0;
  displayBasic: boolean;
  OtherChargesList: AddOnCommission[] = []
  DoorCollectionList: any[]
  _WaybillType: any[]
  userdetails: any[]
  userrole:any[]
  meeting:any[]
  _CommissionType: any[]
  _GSTStatus: any[]
  _Basedon: any[]
  customersiteCode: string
  customerCode: string
  imageselect: string = "";
  _LastAddedDocumentCredit: File
  _TempLastAddedDocumentCredit: File
  _LastAddedDocumentAssessment: File
  _TempLastAddedDocumentAssessment: File
  _TempLastAddedDocumentinCustomer: File
  CreditFile: File[] = [];
  AssessmentFile: File[] = [];
  _submitted: boolean = false
  _submittedCommission: boolean = false
  ConversionImage: any
  CommunicationMailURL: any
  CustomerGSTfileURL: any
  _IsProgressSpinner: boolean = false;
  _SuccessMessage : any;

  creditassessmentsurl: any
  creditworthinessurl: any
  _submittedimage: boolean = false
  _ApprovalComment: any[];
  displaySuccessMSG: boolean = false;
  _RegionList: any[] = [];
_ArticleBasedList: any[] = [];
_SlabFormList: any[] = [];
_2DList: any[] = [];
WayBillList: CustomerSiteContractAddOnCharge[] = [];
HideGeneralRate: boolean = false
HideArticleBased: boolean = false
HideRegionLevel: boolean = false
HideSlab: boolean = false
Hide2DRate: boolean = false
_InclusiveExclusive: any[];
_AddOnChargeType: any[];
_ODACalculationMode: any[];
selectedtabContract: number = 5;
_CustomerSiteContractGeneralForm: FormGroup;
minDate: Date;
_Tempwhom: any
_selectedServiceLocation: string[] = [];
_TempServiceLocationsCode: any


  constructor(private utility: CommonUtilities, private _ContractconversionService: ContractconversionService, private _CustomExceptionService: CustomExceptionService,
    private fb: FormBuilder, private router: Router, private _DomSanitizationService: DomSanitizer,private _CustomerSiteCostAndContractService: CustomerSiteCostAndContractService) {
    this.customersiteCode = history.state?.customersitecode;
  }

  ngOnInit(): void {
    this.utility.pageLoadScript();
    // console.log("sitecode", this.customersiteCode);

    this._ConversionForm = this.fb.group({
      customersitecode: [],
      creditworthinessdocumentURL: [],
      creditworthinessdocumentDOC: [],
      creditassessmentscoresheetURL: [],
      creditassessmentscoresheetDOC: [],
      waybillnumbertype: [],
      waybillnumbertypecode: ['', vConversion],
      bookingcommissiontype: [],
      bookingcommissiontypecode: ['', vConversion],
      abovecardratecommissionpercentage: ['', vConversion],
      agentvehiclereimbursementpercentage: ['', vConversion],
      attachedvehiclereimbursementpercentage: ['', vConversion],
      comments: ['', vConversion],
      recordstatus: [],
      recordstatuscode: [],
      createdby: [],
      createdon: [],
      modifiedby: [],
      modifiedon: [],
      accountingyear: [],
      lstBookingCommission: [],
      lstAddOnCommission: [],
      lstuserdetails: [],
      mEETING_WHERE:['', vConversion],
      wHOM:['', vConversion],
      //cUSTOMERNAME:['', vConversion],
      mEETING_START:['', vConversion],
      mEETING_END:['', vConversion],
      dISCUSSED_POINTS:[]
    });
    this._CustomerSiteContractGeneralForm = this.fb.group({
      rateperqtlperkm: ['', vContract],
      odacalculationmodecode: ['', vContract],
    })
    this.tempconversionform = this.fb.group({
      customersitename: [],
      customername: [],
      bookingcutofftime: [],
      vehicledeparturecutofftime: [],
      pickupcutofftime: [],
      cutoffdateforsignedcontract: [],

    });
    this._Commissionform = this.fb.group({
      belowcardratefrom: ['', vConversion],
      belowcardrateto: ['0', vConversion],
      commissionpercentage: ['', vConversion],
    })

    this._ContractconversionService.GetPageInitializeDetails().subscribe((result) => {

      const resultJSON = JSON.parse(JSON.stringify(result));
      console.log("signoffpageload", resultJSON);
      this.OtherChargesList = resultJSON.lstAddOnCharges
      this._CommissionType = resultJSON.lstCommissionType
      this._WaybillType = resultJSON.lstWaybillType
      this.CustomerList = resultJSON.lstCustomerSite
      this.userdetails = resultJSON.lstuserdetails
      this.userrole = resultJSON.lstWhom
      this.meeting = resultJSON.lstWhere

      // console.log(this.CustomerList);
      this.SelectCustomerList = this.CustomerList.filter(f => f.customersitecode == this.customersiteCode)[0]
      // console.log(this.SelectCustomerList);
      this._ConversionForm.controls['bookingcommissiontypecode'].setValue('MSC00661');
      this._ConversionForm.controls['abovecardratecommissionpercentage'].setValue(12);
      this.customerCode = this.SelectCustomerList.customercode
    this.tempconversionform.controls['customersitename'].setValue(this.SelectCustomerList.customersitename);
    this.tempconversionform.controls['customername'].setValue(this.SelectCustomerList.customername);
    this.ConversionImage = this.SelectCustomerList.signedcontractdocumentURL;
    if(this.SelectCustomerList.cutoffdateforsignedcontract!=null)
    {
    this.tempconversionform.controls['cutoffdateforsignedcontract'].setValue(new Date(this.SelectCustomerList.cutoffdateforsignedcontract));
    }
    else{
      this.tempconversionform.controls['cutoffdateforsignedcontract'].setValue("");
    }

   

    if(this.OtherChargesList != null && this.OtherChargesList.length > 0)
        {
          for(let i = 0;i < this.OtherChargesList.length; i++)
          {
            if(this.OtherChargesList[i].chargeCode == 'AC')
            {
              this.OtherChargesList[i].commissionpercentage = "100";
            }
            else{
              this.OtherChargesList[i].commissionpercentage = "0";
            }
          }
        }
        this.GetById()
    }, error => { this._CustomExceptionService.handleError(error) }
    );
    
  }

  GetById(){
    this._ContractconversionService.GetById(this.customersiteCode).subscribe((result) => {

      const resultJSON = JSON.parse(JSON.stringify(result));
      if (resultJSON.prequoteContractConversionDetail != null || resultJSON.prequoteContractConversionDetail != null) {
        this.ExistConversionList = resultJSON.prequoteContractConversionDetail;
        this.CommissionConfigList = resultJSON.prequoteContractConversionDetail.lstBookingCommission;
        console.log(this.CommissionConfigList);
        this.OtherChargesList = resultJSON.prequoteContractConversionDetail.lstAddOnCommission;               
        this.creditassessmentsurl = resultJSON.prequoteContractConversionDetail.creditassessmentscoresheetURL
        this.creditworthinessurl = resultJSON.prequoteContractConversionDetail.creditworthinessdocumentURL
        //this._ConversionForm.setValue(resultJSON.prequoteContractConversionDetail);
        this._ConversionForm.controls['comments'].setValue("");

        ////////////service location/////////////

        if(resultJSON.prequoteContractConversionDetail.whom != null && resultJSON.prequoteContractConversionDetail.whom != '' && resultJSON.prequoteContractConversionDetail.whom != undefined)
        {
          var splitServiceLocation = resultJSON.prequoteContractConversionDetail.whom.split(',');
        const servicelocations = [];
        for (var i = 0; i < splitServiceLocation.length; i++) {
          servicelocations.push(splitServiceLocation[i]);
        }
        var servicelocationsCode: string[] = [];
        Object.keys(servicelocations).map((Index) => {
          servicelocationsCode.push(servicelocations[Index]);
        });
        this._selectedServiceLocation = servicelocationsCode;
        }
        

        this._TempServiceLocationsCode = resultJSON.prequoteContractConversionDetail.whom;
        this._ConversionForm.controls['agentvehiclereimbursementpercentage'].setValue(resultJSON.prequoteContractConversionDetail.agentvehiclereimbursementpercentage);
        this._ConversionForm.controls['attachedvehiclereimbursementpercentage'].setValue(resultJSON.prequoteContractConversionDetail.attachedvehiclereimbursementpercentage);
        this._ConversionForm.controls['waybillnumbertypecode'].setValue(resultJSON.prequoteContractConversionDetail.waybillnumbertypecode);
        this._ConversionForm.controls['mEETING_WHERE'].setValue(resultJSON.prequoteContractConversionDetail.meetinG_WHERE);
        this._ConversionForm.controls['dISCUSSED_POINTS'].setValue(resultJSON.prequoteContractConversionDetail.discusseD_POINTS);
        this._ConversionForm.controls['mEETING_START'].setValue(new Date(resultJSON.prequoteContractConversionDetail.meetinG_START));
        this._ConversionForm.controls['mEETING_END'].setValue(new Date(resultJSON.prequoteContractConversionDetail.meetinG_END));
        this._ConversionForm.controls['mEETING_END'].setValue(new Date(resultJSON.prequoteContractConversionDetail.meetinG_END));
        
        
        
      }
      else {
        if (this.CommissionConfigList.length == 0) {
          this.CommissionConfigList = [
            { bookingcommissionslabid: "0", customersitecode: this.customersiteCode, belowcardratefrom: "90", belowcardrateto: "100", commissionpercentage: "12", recordstatus: "MSC00001", recordstatuscode: "MSC00001", isdisabledremove: true },
            { bookingcommissionslabid: "0", customersitecode: this.customersiteCode, belowcardratefrom: "80", belowcardrateto: "89.99", commissionpercentage: "10", recordstatus: "MSC00001", recordstatuscode: "MSC00001", isdisabledremove: true },
            { bookingcommissionslabid: "0", customersitecode: this.customersiteCode, belowcardratefrom: "70", belowcardrateto: "79.99", commissionpercentage: "8", recordstatus: "MSC00001", recordstatuscode: "MSC00001", isdisabledremove: true },
            { bookingcommissionslabid: "0", customersitecode: this.customersiteCode, belowcardratefrom: "50", belowcardrateto: "69.99", commissionpercentage: "5", recordstatus: "MSC00001", recordstatuscode: "MSC00001", isdisabledremove: true },
            { bookingcommissionslabid: "0", customersitecode: this.customersiteCode, belowcardratefrom: "1", belowcardrateto: "49.99", commissionpercentage: "5", recordstatus: "MSC00001", recordstatuscode: "MSC00001", isdisabledremove: false }
          ]


        }
      }
      this._ApprovalComment = resultJSON.lstApprovalComment;
      console.log(resultJSON.lstLocationandOperationDetails);
        this.CommunicationMailURL = resultJSON.lstLocationandOperationDetails[0].communicationmaildocumenturl;
        this.CustomerGSTfileURL = resultJSON.lstLocationandOperationDetails[0].gstfile;
        this.tempconversionform.controls['bookingcutofftime'].setValue(new Date(resultJSON.lstLocationandOperationDetails[0].bookingcutofftime));
        this.tempconversionform.controls['vehicledeparturecutofftime'].setValue(new Date(resultJSON.lstLocationandOperationDetails[0].vehicledeparturecutofftime));
        this.tempconversionform.controls['pickupcutofftime'].setValue(new Date(resultJSON.lstLocationandOperationDetails[0].pickupcutofftime));
    }, error => { this._CustomExceptionService.handleError(error) }
    );
    this.CustomerSiteCostAndContractLoad();
  }

  showBasicDialog() {
    this.displayBasic = true;
  }
  AddCommission() {
    this._submittedCommission = true
    if (this._Commissionform.valid) {
      var error = "";
      // if(this._Commissionform.get("belowcardratefrom").value <= 0 || this._Commissionform.get("belowcardratefrom").value == "" || this._Commissionform.get("belowcardratefrom").value == undefined)
      // {
      //   this._CustomExceptionService.handleError("");
      //   return
      // }
      // if(this._Commissionform.get("belowcardrateto").value <= 0 || this._Commissionform.get("belowcardrateto").value == "" || this._Commissionform.get("belowcardrateto").value == undefined)
      // {
      //   this._CustomExceptionService.handleError("");
      //   return
      // }
      if (this.CommissionConfigList.length > 0) {
        for (var i = 0; i < this.CommissionConfigList.length; i++) {
          if (parseFloat(this.CommissionConfigList[i].belowcardratefrom) <= parseFloat(this._Commissionform.get("belowcardratefrom").value) && parseFloat(this.CommissionConfigList[i].belowcardrateto) >= parseFloat(this._Commissionform.get("belowcardratefrom").value)) {
            this._CustomExceptionService.handleError("Invalid Below Card Rate From");
            return
          }
          if (parseFloat(this.CommissionConfigList[i].belowcardratefrom) <= parseFloat(this._Commissionform.get("belowcardrateto").value) && parseFloat(this.CommissionConfigList[i].belowcardrateto) >= parseFloat(this._Commissionform.get("belowcardrateto").value)) {
            this._CustomExceptionService.handleError("Invalid Below Card Rate From");
            return
          }
          if (parseFloat(this.CommissionConfigList[i].commissionpercentage) <= parseFloat(this._Commissionform.get("commissionpercentage").value)) {
            this._CustomExceptionService.handleError("commission percentage is high of " + this.CommissionConfigList[i].commissionpercentage);
            return
          }
        }
      }
      if (error == "") {
        var CommissionTemp: any = {};
        CommissionTemp.bookingcommissionslabid = 0
        CommissionTemp.customersitecode = this.customersiteCode
        CommissionTemp.belowcardratefrom = this._Commissionform.get("belowcardratefrom").value;
        CommissionTemp.belowcardrateto = this._Commissionform.get("belowcardrateto").value;
        CommissionTemp.commissionpercentage = this._Commissionform.get("commissionpercentage").value;
        CommissionTemp.recordstatus = "MSC00001"
        CommissionTemp.recordstatuscode = "MSC00001";
        //SUKListTemp.SkuPhotoFORMFILE = formData;
        //SUKListTemp.SkuPhotoURL = null;

        this.CommissionConfigList.push(CommissionTemp);
        this._Commissionform.reset()
        this._submittedCommission = false
        // this._selectedDocuments.push(this.currentFileInSKU);
        // this._SUK_Form.reset();
        // // this.ClearSUK();
        if (parseFloat(CommissionTemp.belowcardratefrom) > 0) {

          let belowcardratefrom = parseFloat(CommissionTemp.belowcardratefrom) - 1;

          if (belowcardratefrom > 0)
            this._Commissionform.controls['belowcardrateto'].setValue(belowcardratefrom + 0.99);
          else
            this._Commissionform.controls['belowcardrateto'].setValue(0);
          this.DeleteBtnDisabled()
        }
      }
      else {
        this._CustomExceptionService.handleError(error)
      }
    }


  }
  onRowSelectPopup(event: any) {
    // this.displayBasic = false;
    // var row = event.data;
    // console.log("row", row)
    // var temp = "true"
    // this.CustomerCode = row.customercode || 0
    // this._Tempsignform.controls['tempcustomersite'].setValue(row.customersitename);
    // this._Tempsignform.controls['tempcustomer'].setValue(row.customername);
    // this.customersiteCode = row.customersitecode
    
    // alert()
    // this.imageselect = row.signedcontractdocumentURL


    // console.log("row1", this.imageselect)
    // customername
    // customersitename
    // signedcontractdocumentURL

    
  }
  DeleteBtnDisabled() {
    let CommissionConfig = this.CommissionConfigList.length;
    if(CommissionConfig == 0)
    {
      this._Commissionform.controls['belowcardrateto'].setValue(100);
    }
    CommissionConfig = CommissionConfig - 1;
    for (var i = 0; i < this.CommissionConfigList.length; i++) {
      if (CommissionConfig == i) {
        this.CommissionConfigList[i].isdisabledremove = false;
        var belowcardrateto = parseFloat(this.CommissionConfigList[i].belowcardratefrom) - 0.01
        this._Commissionform.controls['belowcardrateto'].setValue(belowcardrateto);
      } else {
        this.CommissionConfigList[i].isdisabledremove = true;        
      }
    }
  }
  OpenConversionImage() {
    var photo = this.ConversionImage.split('\\')
    if (photo[1] != null && photo[1] != '' && photo[1] != undefined  ) {
    window.open(this._Url + "/UploadedFiles/" + this.ConversionImage, "_blank");
    }
    else {
      this._CustomExceptionService.handleWarning("Contract Document is not available");
    }
  }
  OpenCommunicationMailImage() {
    var photo = this.CommunicationMailURL.split('\\')
    if (photo[1] != null && photo[1] != '' && photo[1] != undefined  ) {
      window.open(this._Url + "/UploadedFiles/" + this.CommunicationMailURL, "_blank");
    }
    else {
      this._CustomExceptionService.handleWarning("Communication Mail Document is not available");
    }
    // if (this.CommunicationMailURL != null) {
    // window.open(this._Url + "/UploadedFiles/" + this.CommunicationMailURL, "_blank");
    // }
  }
  OpenGstFileImage() {
    var photo = this.CustomerGSTfileURL.split('\\')
    if (photo[1] != null && photo[1] != '' && photo[1] != undefined  ) {
      window.open(this._Url + "/UploadedFiles/" + this.CustomerGSTfileURL, "_blank");
    }
    else {
      this._CustomExceptionService.handleWarning("GST file is not available");
    }
    // if (this.CustomerGSTfileURL != null) {
    //   window.open(this._Url + "/UploadedFiles/" + this.CustomerGSTfileURL, "_blank");
    // }
   
  }
  OpenCreditWorthiness() {
    if (this._LastAddedDocumentCredit != null) {
      var signoffimage = URL.createObjectURL(this._LastAddedDocumentCredit)
      window.open(signoffimage, "_blank");
    }
    else if (this.creditworthinessurl != null) {
      window.open(this._Url + "/UploadedFiles/" + this.creditworthinessurl, "_blank");
    }
    else {
      this._CustomExceptionService.handleWarning("Please select Document");
    }
  }
  OpenAssessmentImage() {
    if (this._LastAddedDocumentAssessment != null) {
      var signoffimage = URL.createObjectURL(this._LastAddedDocumentAssessment)
      window.open(signoffimage, "_blank");
    }
    else if (this.creditassessmentsurl != null) {
      window.open(this._Url + "/UploadedFiles/" + this.creditassessmentsurl, "_blank");
    }
    else {
      this._CustomExceptionService.handleWarning("Please select Document");
    }
  }
  CreditDocumentSelect(event, document) {
    this._TempLastAddedDocumentCredit = event.currentFiles[0]
    if (this._TempLastAddedDocumentCredit.size > 3000000) {
      this._submittedimage = true
      this._CustomExceptionService.handleWarning("Your File size does not exceed 3 MB")
      document.clear();
      return
    }
    this._LastAddedDocumentCredit = event.currentFiles[0];
    this._submittedimage = false
    document.clear();
  }
  AssessmentDocumentSelect(event, document1) {
    this._TempLastAddedDocumentAssessment = event.currentFiles[0]
    if (this._TempLastAddedDocumentAssessment.size > 3000000) {
      this._submittedimage = true
      this._CustomExceptionService.handleWarning("Your File size does not exceed 3 MB")
      document1.clear();
      return
    }
    this._LastAddedDocumentAssessment = event.currentFiles[0];
    this._submittedimage = false
    document1.clear();
  }
  onDocumentClearCredit() {
    this._LastAddedDocumentCredit = null;
  }
  onDocumentClearAssessment() {
    this._LastAddedDocumentAssessment = null;
  }
  formContractconverstion(creditdocuments: File[], assessmentdocuments: File[]) {
    let time = new Date();
    const formData: FormData = new FormData();
    //TimeStamp Add:


    for (var x in creditdocuments) {
      if (creditdocuments[x] != undefined) {
        //var index = p_documentdetails.findIndex(obj => obj.attachmentname == documents[x].name);
        //console.log("Index", index);
        //if (index != -1) {
        var NewFileName = creditdocuments[x].name || "";
        // p_documentdetails[index].attachmentname = NewFileName;
        // p_documentdetails[index].attachmenturl = NewFileName;
        formData.append('iFormFileCreditWorthy', creditdocuments[x], NewFileName);
      }
    }
    for (var x in assessmentdocuments) {
      if (assessmentdocuments[x] != undefined) {
        //var index = p_documentdetails.findIndex(obj => obj.attachmentname == documents[x].name);
        //console.log("Index", index);
        //if (index != -1) {
        var NewFileName1 = assessmentdocuments[x].name || "";
        // p_documentdetails[index].attachmentname = NewFileName;
        // p_documentdetails[index].attachmenturl = NewFileName;
        formData.append('iFormFileAssessmentScore', assessmentdocuments[x], NewFileName1);
      }
    }
    var _ContractConversionOBJ = {
      "PrequoteContractConversion": this.ContractConversion,
    };
    var _CustomersiteFD = JSON.stringify(_ContractConversionOBJ);
    formData.append('strPrequoteContractConversion', _CustomersiteFD);
    return (formData);

  }
  onSaveConversion() {
    this._submitted = true

    if (!this._TempServiceLocationsCode == null) {      
      this._CustomExceptionService.handleError("please select Whom");
      return;
    }
    if(!this._ConversionForm.controls['waybillnumbertypecode'].value){
      this._CustomExceptionService.handleError("please select Waybill Type");
      return;
    }
    if(!this._ConversionForm.controls['agentvehiclereimbursementpercentage'].value){
      this._CustomExceptionService.handleError("please update Agent Vehicle Reimbursement");
      return;
    }
    if(!this._ConversionForm.controls['attachedvehiclereimbursementpercentage'].value){
      this._CustomExceptionService.handleError("please update Attached Vehicle Reimbursement");
      return;
    }
    if(!this._ConversionForm.controls['comments'].value){
      this._CustomExceptionService.handleError("please update Comments");
      return;
    }
    if (this._ConversionForm.valid) {
      this.ContractConversion = this._ConversionForm.value

      this.ContractConversion.customersitecode = this.customersiteCode
      if (this._TempServiceLocationsCode == '') {
        this.ContractConversion.wHOM = null
      }
      else
      {
        this.ContractConversion.wHOM = this._TempServiceLocationsCode
      }

      this.ContractConversion.mEETING_START = this._ConversionForm.get("mEETING_START").value
      this.ContractConversion.mEETING_END = this._ConversionForm.get("mEETING_END").value
      this.ContractConversion.mEETING_WHERE = this._ConversionForm.get("mEETING_WHERE").value
      this.ContractConversion.dISCUSSED_POINTS = this._ConversionForm.get("dISCUSSED_POINTS").value
      
      this.ContractConversion.createdby = "admin"
      // this.ContractConversion.createdon = new Date()
      this.ContractConversion.modifiedby = "admin"
      //this.ContractConversion.loggeduser = this.loggeduser
      //this.ContractConversion.loggedrole = this.loggedrole

      // this.ContractConversion.modifiedon = new Date()
      // this.ContractConversion.accountingyear = new Date().getFullYear()
      if (this._LastAddedDocumentCredit == undefined || this._LastAddedDocumentCredit == null) {
        this.ContractConversion.creditworthinessdocumentURL = ""
      } else {
        this.ContractConversion.creditworthinessdocumentURL = this._LastAddedDocumentCredit.name || ""
      }
      if (this._LastAddedDocumentAssessment == undefined || this._LastAddedDocumentAssessment == null) {
        this.ContractConversion.creditassessmentscoresheetURL = ""
      } else {
        this.ContractConversion.creditassessmentscoresheetURL = this._LastAddedDocumentAssessment.name || ""
      }

      for (var i = 0; i < this.OtherChargesList.length; i++) {
        this.OtherChargesList[i].customersitecode = this.customersiteCode
        // this.OtherChargesList[i].recordstatuscode="MSC00001"
      }
      this.ContractConversion.lstBookingCommission = this.CommissionConfigList
      this.ContractConversion.lstAddOnCommission = this.OtherChargesList
      this.ContractConversion.lstuserdetails = this.userdetails
      // console.log(this.ContractConversion)

      this.CreditFile.push(this._LastAddedDocumentCredit)
      this.AssessmentFile.push(this._LastAddedDocumentAssessment)


      //this.creditassessmentsurl
      //this.creditworthinessurl
      if (this._LastAddedDocumentCredit == undefined) {
        if (this.creditworthinessurl != null) {
          var photo = this.creditworthinessurl.split('\\')
          //  console.log(photo)
          this.ContractConversion.creditworthinessdocumentURL = photo[1];
        }
      }
      if (this._LastAddedDocumentAssessment == undefined) {
        if (this.creditassessmentsurl != null) {
          var photo = this.creditassessmentsurl.split('\\')
          this.ContractConversion.creditworthinessdocumentURL = photo[1];
        }
      }
      var PreQuoteConversion = this.formContractconverstion(this.CreditFile, this.AssessmentFile);
      if (this.ExistConversionList == null || this.ExistConversionList == undefined || this.ExistConversionList.length == 0) {
        this._IsProgressSpinner = true;
        this._ContractconversionService.InsertPrequoteContractConversion(PreQuoteConversion).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            
            this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
            this.clearconversion()
            this._SuccessMessage = resutJSON.tranStatus.lstErrorItem[0].message;
            this._IsProgressSpinner = false;
            this.displaySuccessMSG = true;
          }
          else {
            this._IsProgressSpinner = false;
            this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
          }
        }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error) }
        );
      } else {
        this._IsProgressSpinner = true;
        this._ContractconversionService.UpdatePrequoteContractConversion(PreQuoteConversion).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            this.clearconversion();
            this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
            this._SuccessMessage = resutJSON.tranStatus.lstErrorItem[0].message;
            this._IsProgressSpinner = false;
            this.displaySuccessMSG = true;
          }
          else {
            this._IsProgressSpinner = false;
            this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
          }
        }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error) }
        );
      }

    }


  }
  RemoveCommission() {
    this._submittedCommission = false
    this._Commissionform.reset()
  }
  clearconversion() {
    this._submitted = false
    this._ConversionForm.reset()
    this.CommissionConfigList = []
    for (var i = 0; i < this.OtherChargesList.length; i++) {
      this.OtherChargesList[i].commissionpercentage = ""
    }
    this.tempconversionform.reset()
    this.onDocumentClearCredit()

    this.onDocumentClearAssessment()
    // this.OtherChargesList = []
  }
  OpenImage() {
    // alert("ok");
    //   var image =this.imageselect
    //  var w= window.open("image");
    //  w.document.write(this.imageselect, "_blank");
    // let URL =   this._DomSanitizationService.bypassSecurityTrustUrl(this.imageselect)
    let value = null
    value = this.imageselect
    // console.log("row 2", value)
    window.open(value, '_blank')
  }

  RemoveCommisiongrid(RowIndex) {
    //alert(RowIndex);
    if (this.CommissionConfigList.length > 1) {
      var index = this.CommissionConfigList.indexOf(RowIndex);
      this.CommissionConfigList.splice(index, 1)
    }
    else {
      var index = this.CommissionConfigList.indexOf(RowIndex);
      this.CommissionConfigList.splice(index, 1);
      //this.AddNewSlab('');
      //this.MinimumRange = false;
    }
    this.DeleteBtnDisabled()
  }
  Ok()
  {
    this.displaySuccessMSG = false;
    this.router.navigate(['/vPrequotecontractconversion']);
  }
  CustomerSiteCostAndContractLoad() {
    this._CustomerSiteCostAndContractService.CustomerSiteCostAndContractServiceInit().subscribe((result) => {
      const resultJSON = JSON.parse(JSON.stringify(result));
      //console.log("costing&&&", resultJSON);
      if (resultJSON.tranStatus.result == true) {
        this._AddOnChargeType = resultJSON.lstAddOnChargeType;
        this._InclusiveExclusive = resultJSON.lstODAInclusiveOrExclusive;
        this._ODACalculationMode = resultJSON.lstODACalculationMode;
        // this._SkuTypeList = this.SUKList

        

        //this._Hub = resultJSON.lstHub;


        var CustCode = this.customersiteCode
        this._CustomerSiteCostAndContractService.GetById(CustCode).subscribe((result) => {
          const resultJSON = JSON.parse(JSON.stringify(result));
          //console.log("dd values", resultJSON);
          if (resultJSON.lstGeneralContract.length > 0) {
            this._CustomerSiteContractGeneralForm.controls['odacalculationmodecode'].setValue(resultJSON.lstGeneralContract[0].odacalculationmodecode);
            this._CustomerSiteContractGeneralForm.controls['rateperqtlperkm'].setValue(resultJSON.lstGeneralContract[0].rateperqtlperkm);
          }
          var splitContractTypes = resultJSON.customerSiteContractDetail.contracttypescode.split(',');       
            if (splitContractTypes != null) {
              for (var i = 0; i < splitContractTypes.length; i++) {
                if (splitContractTypes[i] == 'MSC00081') {
                  this.HideGeneralRate = true
                }
                if (splitContractTypes[i] == 'MSC00083') {
                  this.HideArticleBased = true
                }
                if (splitContractTypes[i] == 'MSC00082') {
                  this.HideRegionLevel = true
                }
                if (splitContractTypes[i] == 'MSC00084') {
                  this.HideSlab = true
                }
                if (splitContractTypes[i] == 'MSC00104') {
                  this.Hide2DRate = true
                }
              }
            }
            
            this._RegionList = resultJSON.lstRegionContract;
            if (resultJSON.lstRegionContract != null) {
              for (var i = 0; i < resultJSON.lstRegionContract.length; i++) {
                this._RegionList[i].customersitecode = resultJSON.lstRegionContract[i].customersitecode;
                this._RegionList[i].frombranchcode = resultJSON.lstRegionContract[i].frombranchcode;
                this._RegionList[i].frombranch = resultJSON.lstRegionContract[i].frombranch;
                this._RegionList[i].toregioncode = resultJSON.lstRegionContract[i].toregioncode;
                this._RegionList[i].toregion = resultJSON.lstRegionContract[i].toregion;
                this._RegionList[i].articlecode = resultJSON.lstRegionContract[i].articlecode;
                this._RegionList[i].article = resultJSON.lstRegionContract[i].article;
                this._RegionList[i].ratetypecode = resultJSON.lstRegionContract[i].ratetypecode;
                this._RegionList[i].ratetype = resultJSON.lstRegionContract[i].ratetype;
                this._RegionList[i].rate = resultJSON.lstRegionContract[i].rate;
                this._RegionList[i].dcratetypecode = resultJSON.lstRegionContract[i].dcratetypecode;
                this._RegionList[i].dcratetype = resultJSON.lstRegionContract[i].dcratetype;
                this._RegionList[i].dcrate = resultJSON.lstRegionContract[i].dcrate;
                this._RegionList[i].ddratetypecode = resultJSON.lstRegionContract[i].ddratetypecode;
                this._RegionList[i].ddratetype = resultJSON.lstRegionContract[i].ddratetype;
                this._RegionList[i].ddrate = resultJSON.lstRegionContract[i].ddrate;
                this._RegionList[i].acratetypecode = resultJSON.lstRegionContract[i].acratetypecode;
                this._RegionList[i].acratetype = resultJSON.lstRegionContract[i].acratetype;
                this._RegionList[i].acrate = resultJSON.lstRegionContract[i].acrate;
                this._RegionList[i].inclusiveorexclusivecode = resultJSON.lstRegionContract[i].inclusiveorexclusivecode;
                this._RegionList[i].inclusiveorexclusive = resultJSON.lstRegionContract[i].inclusiveorexclusive;
                this._RegionList[i].isneedreversebooking = resultJSON.lstRegionContract[i].isneedreversebooking;
                this._RegionList[i].isneedreversebookingcode = resultJSON.lstRegionContract[i].isneedreversebookingcode;
                this._RegionList[i].lstDCDDACSlabs = resultJSON.lstRegionContract[i].lstDCDDACSlabs;
                if (resultJSON.lstRegionContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstRegionContract[i].lstDCDDACSlabs.length; j++) {
                    this._RegionList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._RegionList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._RegionList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._RegionList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._RegionList[i].lstDCDDACSlabs.slabto = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabto;
                    this._RegionList[i].lstDCDDACSlabs.slabrate = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
              }
            }          
            this._ArticleBasedList = resultJSON.lstArticleContract;                      
            if (resultJSON.lstArticleContract != null) {
              for (var i = 0; i < resultJSON.lstArticleContract.length; i++) {
                this._ArticleBasedList[i].customersitecode = resultJSON.lstArticleContract[i].customersitecode;
                this._ArticleBasedList[i].frombranchcode = resultJSON.lstArticleContract[i].frombranchcode;
                this._ArticleBasedList[i].frombranch = resultJSON.lstArticleContract[i].frombranch;
                this._ArticleBasedList[i].tobranchcode = resultJSON.lstArticleContract[i].tobranchcode;
                this._ArticleBasedList[i].tobranch = resultJSON.lstArticleContract[i].tobranch;
                this._ArticleBasedList[i].articlecode = resultJSON.lstArticleContract[i].articlecode;
                this._ArticleBasedList[i].article = resultJSON.lstArticleContract[i].article;
                this._ArticleBasedList[i].ratetypecode = resultJSON.lstArticleContract[i].ratetypecode;
                this._ArticleBasedList[i].ratetype = resultJSON.lstArticleContract[i].ratetype;
                this._ArticleBasedList[i].rate = resultJSON.lstArticleContract[i].rate;
                this._ArticleBasedList[i].discount = resultJSON.lstArticleContract[i].discount;
                this._ArticleBasedList[i].finalrate = resultJSON.lstArticleContract[i].finalrate;
                this._ArticleBasedList[i].dcratetypecode = resultJSON.lstArticleContract[i].dcratetypecode;
                this._ArticleBasedList[i].dcratetype = resultJSON.lstArticleContract[i].dcratetype;
                this._ArticleBasedList[i].dcrate = resultJSON.lstArticleContract[i].dcrate;
                this._ArticleBasedList[i].ddratetypecode = resultJSON.lstArticleContract[i].ddratetypecode;
                this._ArticleBasedList[i].ddratetype = resultJSON.lstArticleContract[i].ddratetype;
                this._ArticleBasedList[i].ddrate = resultJSON.lstArticleContract[i].ddrate;
                this._ArticleBasedList[i].acratetypecode = resultJSON.lstArticleContract[i].acratetypecode;
                this._ArticleBasedList[i].acratetype = resultJSON.lstArticleContract[i].acratetype;
                this._ArticleBasedList[i].acrate = resultJSON.lstArticleContract[i].acrate;
                this._ArticleBasedList[i].inclusiveorexclusivecode = resultJSON.lstArticleContract[i].inclusiveorexclusivecode;
                this._ArticleBasedList[i].inclusiveorexclusive = resultJSON.lstArticleContract[i].inclusiveorexclusive;
                this._ArticleBasedList[i].isneedreversebooking = resultJSON.lstArticleContract[i].isneedreversebooking;
                this._ArticleBasedList[i].isneedreversebookingcode = resultJSON.lstArticleContract[i].isneedreversebookingcode;
                this._ArticleBasedList[i].lstDCDDACSlabs = resultJSON.lstArticleContract[i].lstDCDDACSlabs;

                this._ArticleBasedList[i].distance = resultJSON.lstArticleContract[i].distance;
                this._ArticleBasedList[i].quintalRateperKM = resultJSON.lstArticleContract[i].quintalRateperKM;

                if (resultJSON.lstArticleContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstArticleContract[i].lstDCDDACSlabs.length; j++) {
                    this._ArticleBasedList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._ArticleBasedList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._ArticleBasedList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._ArticleBasedList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._ArticleBasedList[i].lstDCDDACSlabs.slabto = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabto;
                    this._ArticleBasedList[i].lstDCDDACSlabs.slabrate = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
              }
            }
            if (resultJSON.lstSlabContract != null) {
              this._SlabFormList = resultJSON.lstSlabContract;
              for (var i = 0; i < resultJSON.lstSlabContract.length; i++) {
                this._SlabFormList[i].customersitecode = resultJSON.lstSlabContract[i].customersitecode;
                this._SlabFormList[i].frombranchcode = resultJSON.lstSlabContract[i].frombranchcode;
                this._SlabFormList[i].frombranch = resultJSON.lstSlabContract[i].frombranch;
                this._SlabFormList[i].tobranchcode = resultJSON.lstSlabContract[i].tobranchcode;
                this._SlabFormList[i].tobranch = resultJSON.lstSlabContract[i].tobranch;
                this._SlabFormList[i].articlecode = resultJSON.lstSlabContract[i].articlecode;
                this._SlabFormList[i].article = resultJSON.lstSlabContract[i].article;
                this._SlabFormList[i].ratetypecode = resultJSON.lstSlabContract[i].ratetypecode;
                this._SlabFormList[i].ratetype = resultJSON.lstSlabContract[i].ratetype;
                this._SlabFormList[i].rate = resultJSON.lstSlabContract[i].rate;
                this._SlabFormList[i].dcratetypecode = resultJSON.lstSlabContract[i].dcratetypecode;
                this._SlabFormList[i].dcratetype = resultJSON.lstSlabContract[i].dcratetype;
                this._SlabFormList[i].dcrate = resultJSON.lstSlabContract[i].dcrate;
                this._SlabFormList[i].ddratetypecode = resultJSON.lstSlabContract[i].ddratetypecode;
                this._SlabFormList[i].ddratetype = resultJSON.lstSlabContract[i].ddratetype;
                this._SlabFormList[i].ddrate = resultJSON.lstSlabContract[i].ddrate;
                this._SlabFormList[i].acratetypecode = resultJSON.lstSlabContract[i].acratetypecode;
                this._SlabFormList[i].acratetype = resultJSON.lstSlabContract[i].acratetype;
                this._SlabFormList[i].acrate = resultJSON.lstSlabContract[i].acrate;
                this._SlabFormList[i].inclusiveorexclusivecode = resultJSON.lstSlabContract[i].inclusiveorexclusivecode;
                this._SlabFormList[i].inclusiveorexclusive = resultJSON.lstSlabContract[i].inclusiveorexclusive;
                this._SlabFormList[i].isneedreversebooking = resultJSON.lstSlabContract[i].isneedreversebooking;
                this._SlabFormList[i].isneedreversebookingcode = resultJSON.lstSlabContract[i].isneedreversebookingcode;
                this._SlabFormList[i].lstDCDDACSlabs = resultJSON.lstSlabContract[i].lstDCDDACSlabs;
                if (resultJSON.lstSlabContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstSlabContract[i].lstDCDDACSlabs.length; j++) {
                    this._SlabFormList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._SlabFormList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._SlabFormList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._SlabFormList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._SlabFormList[i].lstDCDDACSlabs.slabto = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabto;
                    this._SlabFormList[i].lstDCDDACSlabs.slabrate = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
                if (resultJSON.lstSlabContract[i].lstRateSlabs != null) {
                  for (var j = 0; j < resultJSON.lstSlabContract[i].lstRateSlabs.length; j++) {
                    this._SlabFormList[i].lstRateSlabs.customersitecode = resultJSON.lstSlabContract[i].lstRateSlabs[j].customersitecode;
                    this._SlabFormList[i].lstRateSlabs.contracttypecode = resultJSON.lstSlabContract[i].lstRateSlabs[j].contracttypecode;
                    this._SlabFormList[i].lstRateSlabs.contracttype = resultJSON.lstSlabContract[i].lstRateSlabs[j].contracttypecode;
                    this._SlabFormList[i].lstRateSlabs.slabfrom = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabfrom;
                    this._SlabFormList[i].lstRateSlabs.slabto = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabrate;
                    this._SlabFormList[i].lstRateSlabs.slabrate = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabto;
                  }
                }
              }
            }
            if (resultJSON.lstTwoDContract != null) {
              this._2DList = resultJSON.lstTwoDContract;
              for (var i = 0; i < resultJSON.lstTwoDContract.length; i++) {
                this._2DList[i].customersitecode = resultJSON.lstTwoDContract[i].customersitecode;
                this._2DList[i].frombranchcode = resultJSON.lstTwoDContract[i].frombranchcode;
                this._2DList[i].frombranch = resultJSON.lstTwoDContract[i].frombranch;
                this._2DList[i].toKM = resultJSON.lstTwoDContract[i].toKM;
                this._2DList[i].articlecode = resultJSON.lstTwoDContract[i].articlecode;
                this._2DList[i].article = resultJSON.lstTwoDContract[i].article;
                this._2DList[i].ratetypecode = resultJSON.lstTwoDContract[i].ratetypecode;
                this._2DList[i].ratetype = resultJSON.lstTwoDContract[i].ratetype;
                this._2DList[i].rate = resultJSON.lstTwoDContract[i].rate;
                this._2DList[i].dcratetypecode = resultJSON.lstTwoDContract[i].dcratetypecode;
                this._2DList[i].dcratetype = resultJSON.lstTwoDContract[i].dcratetype;
                this._2DList[i].dcrate = resultJSON.lstTwoDContract[i].dcrate;
                this._2DList[i].ddratetypecode = resultJSON.lstTwoDContract[i].ddratetypecode;
                this._2DList[i].ddratetype = resultJSON.lstTwoDContract[i].ddratetype;
                this._2DList[i].ddrate = resultJSON.lstTwoDContract[i].ddrate;
                this._2DList[i].acratetypecode = resultJSON.lstTwoDContract[i].acratetypecode;
                this._2DList[i].acratetype = resultJSON.lstTwoDContract[i].acratetype;
                this._2DList[i].acrate = resultJSON.lstTwoDContract[i].acrate;
                this._2DList[i].inclusiveorexclusivecode = resultJSON.lstTwoDContract[i].inclusiveorexclusivecode;
                this._2DList[i].inclusiveorexclusive = resultJSON.lstTwoDContract[i].inclusiveorexclusive;
                this._2DList[i].isneedreversebooking = resultJSON.lstTwoDContract[i].isneedreversebooking;
                this._2DList[i].isneedreversebookingcode = resultJSON.lstTwoDContract[i].isneedreversebookingcode;
                this._2DList[i].lstDCDDACSlabs = resultJSON.lstTwoDContract[i].lstDCDDACSlabs;
                if (resultJSON.lstTwoDContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstTwoDContract[i].lstDCDDACSlabs.length; j++) {
                    this._2DList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._2DList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._2DList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._2DList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._2DList[i].lstDCDDACSlabs.slabto = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabto;
                    this._2DList[i].lstDCDDACSlabs.slabrate = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
                if (resultJSON.lstTwoDContract[i].lstRateSlabs != null) {
                  for (var j = 0; j < resultJSON.lstTwoDContract[i].lstRateSlabs.length; j++) {
                    this._2DList[i].lstRateSlabs.customersitecode = resultJSON.lstTwoDContract[i].lstRateSlabs[j].customersitecode;
                    this._2DList[i].lstRateSlabs.contracttypecode = resultJSON.lstTwoDContract[i].lstRateSlabs[j].contracttypecode;
                    this._2DList[i].lstRateSlabs.contracttype = resultJSON.lstTwoDContract[i].lstRateSlabs[j].contracttypecode;
                    this._2DList[i].lstRateSlabs.slabfrom = resultJSON.lstTwoDContract[i].lstRateSlabs[j].slabfrom;
                    this._2DList[i].lstRateSlabs.slabto = resultJSON.lstTwoDContract[i].lstRateSlabs[j].slabto;
                    this._2DList[i].lstRateSlabs.slabrate = resultJSON.lstTwoDContract[i].lstRateSlabs[j].slabrate;
                  }
                }
              }
            }

            if (resultJSON.lstAddOnCharge != null) {
              this.WayBillList = resultJSON.lstAddOnCharge;
              for (var i = 0; i < resultJSON.lstAddOnCharge.length; i++) {
                this.WayBillList[i].customersitecode = resultJSON.lstAddOnCharge[i].customersitecode;
                this.WayBillList[i].chargetype = (this._AddOnChargeType || []).filter(f => f.chargeCode == resultJSON.lstAddOnCharge[i].chargetypecode)[0].chargeName;
                this.WayBillList[i].chargetypecode = resultJSON.lstAddOnCharge[i].chargetypecode;
                this.WayBillList[i].chargeratetypecode = resultJSON.lstAddOnCharge[i].chargeratetypecode;
                this.WayBillList[i].chargeratetype = resultJSON.lstAddOnCharge[i].chargeratetype;
                this.WayBillList[i].chargecodeid = resultJSON.lstAddOnCharge[i].chargecodeid;
                //this.WayBillList[i].chargecodeName = (this._AddOnChargeType || []).filter(f => f.chargeCode == resultJSON.lstAddOnCharge[i].chargecodeid)[0].chargeName;
                this.WayBillList[i].rate = resultJSON.lstAddOnCharge[i].rate;
                this.WayBillList[i].inclusiveorexclusivecode = resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode;
                this.WayBillList[i].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode)[0].metasubdescription;
                this.WayBillList[i].printinothercharge = resultJSON.lstAddOnCharge[i].printinothercharge;
                this.WayBillList[i].lstAddOnSlabs = resultJSON.lstAddOnCharge[i].lstAddOnSlabs;
                if (resultJSON.lstAddOnCharge[i].lstAddOnSlabs != null) {
                  for (var j = 0; j < resultJSON.lstAddOnCharge[i].lstAddOnSlabs.length; j++) {
                    this.WayBillList[i].lstAddOnSlabs.customersitecode = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].customersitecode;
                    this.WayBillList[i].lstAddOnSlabs.slabfrom = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].slabfrom;
                    this.WayBillList[i].lstAddOnSlabs.slabto = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].slabto;
                    this.WayBillList[i].lstAddOnSlabs.slabrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabrate;
                    this.WayBillList[i].lstAddOnSlabs.slabaddrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabaddrate;
                    this.WayBillList[i].lstAddOnSlabs.chargecodeid = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Chargecodeid;
                  }
                }
              }
            }
            this._IsProgressSpinner = false;          
        }, error => {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(error);
        });
      }
    }, error => {
      this._IsProgressSpinner = false;
      this._CustomExceptionService.handleError(error);
    });
  }

  GetServiceLocations(event) {

    var ServiceLocationsCode = "";
    var ServiceLocationsName = "";
    var selectedServiceLocations = event.value
    for (var i = 0; i < selectedServiceLocations.length; i++) {
      if (ServiceLocationsCode == "") {
        ServiceLocationsCode = selectedServiceLocations[i]
        // ServiceLocationsName = selectedServiceLocations[i].statename;
      }
      else {
        ServiceLocationsCode = ServiceLocationsCode + "," + selectedServiceLocations[i]
        // ServiceLocationsName = ServiceLocationsName + "," + selectedServiceLocations[i].statename;
      }

    }
    this._TempServiceLocationsCode = ServiceLocationsCode
    //this._TempServiceLocations = ServiceLocationsName
    //  console.log("refv",selectedcredittype.metasubcode);

  }
}

